import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import CV from '@/components/CV'
import VideoPlayer from '@/components/VideoPlayer'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
    },
    {
      path: '/cv',
      name: 'CV',
      component: CV,
    },
    {
      path: '/video/:id',
      name: 'Video',
      component: VideoPlayer,
    },
  ],
})
